import React from 'react'

function SimpleLayoutIcon () {
  return (
    <div>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='38'
        height='30'
        viewBox='0 0 38 30'
      >
        <path
          id='web_24dp_000000_FILL1_wght300_GRAD0_opsz24'
          d='M103.615-750a3.49,3.49,0,0,1-2.565-1.05,3.49,3.49,0,0,1-1.05-2.565v-22.769a3.489,3.489,0,0,1,1.05-2.565,3.49,3.49,0,0,1,2.565-1.05h30.769a3.49,3.49,0,0,1,2.565,1.05,3.489,3.489,0,0,1,1.05,2.565v22.769a3.49,3.49,0,0,1-1.05,2.565,3.49,3.49,0,0,1-2.565,1.05Zm0-3H124.5v-7.385H103v6.769a.587.587,0,0,0,.193.423.587.587,0,0,0,.423.193Zm23.885,0h6.884a.587.587,0,0,0,.423-.193.587.587,0,0,0,.193-.423v-17.154h-7.5ZM103-763.385h21.5v-7.385H103Z'
          transform='translate(-100 780)'
          fill='#251a88'
        />
      </svg>
    </div>
  )
}

export default SimpleLayoutIcon
